import React from 'react';

const StudioAssessmentBenchmark = (props: any) => {
  const { children, data, style, className, benchmarkConfig, ...restProps } = props || {};
  const { commonData, riskLevel } = data || {};
  const { data: propsCommonData = [], loading, errorMsg } = commonData || {};

  function cartesianCombine<T, U>(a: T[], b: U[]) {
    const result: (T & U)[] = [];
    for (const itemA of a) {
      for (const itemB of b) {
        result.push({ ...itemA, ...itemB });
      }
    }
    return result;
  }

  // 检查 propsCommonData 是否为数组，确保后续逻辑处理安全
  let commonDataCombine: any[] = [];
  if (Array.isArray(propsCommonData)) {
    // 数据清洗和合并，只在 propsCommonData 有效时执行
    commonDataCombine = Array.from(
      propsCommonData.reduce((map, item) => {
        const key = `${item.category}-${item.index}`;
        if (!map.has(key)) {
          const { studio, update_date, value, version, ...rest } = item; // 去除不必要字段
          map.set(key, rest); // 使用唯一键保存
        }
        return map;
      }, new Map()).values()
    );
  }

  // 生成 performanceData，依赖清洗后的 commonDataCombine 和 benchmarkConfig
  const performanceData = cartesianCombine(commonDataCombine, benchmarkConfig || []);

  return (
    React.Children.map(children, (child: any) =>
      React.cloneElement(child, {
        ...restProps,
        data,
        benchmarkConfig,
        performanceData,
        performanceLoading: loading,
        performanceError: !!errorMsg,
        riskData: riskLevel
      })
    )
  );
};

export default StudioAssessmentBenchmark;